// import { Int64 } from "int64-buffer";

DataView.prototype.getString = function (offset, length) {
  var end = typeof length == "number" ? offset + length : this.byteLength;
  var text = "";
  var val = -1;

  while (offset < this.byteLength && offset < end) {
    val = this.getUint8(offset++);
    if (val == 0) break;
    text += String.fromCharCode(val);
  }

  return text;
};

DataView.prototype.getInt64 = function (byteOffset) {
  const left = this.getUint32(byteOffset);
  const right = this.getUint32(byteOffset + 4);

  const combined = 2 ** 32 * left + right;

  if (!Number.isSafeInteger(combined)) {
    console.warn(combined, "exceeds MAX_SAFE_INTEGER. Precision may be lost");
    return -1;
  }

  return combined;
};

export function compactMarketData(dataview) {
  if (dataview.byteLength === 42) {
    return {
      exchange: dataview.getInt8(1),
      instrumentToken: dataview.getInt32(2),
      ltp: dataview.getInt32(6),
      change: dataview.getInt32(10),
      ltt: dataview.getInt32(14),
      lowDpr: dataview.getInt32(18),
      highDpr: dataview.getInt32(22),
      currentOpenInterest: dataview.getInt32(26),
      initialOpenInterest: dataview.getInt32(30),
      bidPrice: dataview.getInt32(34),
      askPrice: dataview.getInt32(38),
    };
  } else if (dataview.byteLength === 46) {
    return {
      exchange: dataview.getInt8(1),
      instrumentToken: dataview.getInt32(2),
      ltp: dataview.getInt32(6),
      change: dataview.getInt32(10),
      ltt: dataview.getInt32(14),
      lowDpr: dataview.getInt32(18),
      highDpr: dataview.getInt32(22),
      currentOpenInterest: dataview.getInt32(26),
      initialOpenInterest: dataview.getInt32(30),
      bidPrice: dataview.getInt32(34),
      askPrice: dataview.getInt32(38),
      ltq: dataview.getInt32(42),
    };
  } else {
    return {
      exchange: 0,
      instrumentToken: 0,
      ltp: 0,
      change: 0,
      ltt: 0,
      lowDpr: 0,
      highDpr: 0,
      currentOpenInterest: 0,
      initialOpenInterest: 0,
      bidPrice: 0,
      askPrice: 0,
      ltq: 0,
    };
  }
}

export function detailedMarketData(dataview) {
  return {
    exchange: dataview.getInt8(1),
    instrumentToken: dataview.getInt32(2),
    lastTradedPrice: dataview.getInt32(6),
    lastTradedTime: dataview.getInt32(10),
    lastTradedQuantity: dataview.getInt32(14),
    volume: dataview.getInt32(18),
    bestBidPrice: dataview.getInt32(22),
    bestBidQuantity: dataview.getInt32(26),
    bestAskPrice: dataview.getInt32(30),
    bestAskQuantity: dataview.getInt32(34),
    totalBuyQuantity: dataview.getInt64(38),
    totalSellQuantity: dataview.getInt64(46),
    averageTradePrice: dataview.getInt32(54),
    exchangeTimestamp: dataview.getInt32(58),
    openPrice: dataview.getInt32(62),
    highPrice: dataview.getInt32(66),
    lowPrice: dataview.getInt32(70),
    closePrice: dataview.getInt32(74),
    yearlyHighPrice: dataview.getInt32(78),
    yearlyLowPrice: dataview.getInt32(82),
    lowDPR: dataview.getInt32(86),
    HighDPR: dataview.getInt32(90),
    currentOpenInterest: dataview.getInt32(94),
    initialOpenInterest: dataview.getInt32(98),
  };
}

export function spreadData(dataview) {
  return {
    exchange: dataview.getInt8(1),
    instrumentToken1: dataview.getInt32(2),
    instrumentToken2: dataview.getInt32(6),
    exchangeTimestamp: dataview.getInt32(10),
    totalBuyers: dataview.getInt32(14),
    totalSellers: dataview.getInt32(18),
    buyers: [
      dataview.getInt32(22),
      dataview.getInt32(26),
      dataview.getInt32(30),
      dataview.getInt32(34),
      dataview.getInt32(38),
    ],
    bidPrices: [
      dataview.getInt32(42),
      dataview.getInt32(46),
      dataview.getInt32(50),
      dataview.getInt32(54),
      dataview.getInt32(58),
    ],
    bidQtys: [
      dataview.getInt32(62),
      dataview.getInt32(66),
      dataview.getInt32(70),
      dataview.getInt32(74),
      dataview.getInt32(78),
    ],
    sellers: [
      dataview.getInt32(82),
      dataview.getInt32(86),
      dataview.getInt32(90),
      dataview.getInt32(94),
      dataview.getInt32(98),
    ],
    askPrices: [
      dataview.getInt32(102),
      dataview.getInt32(106),
      dataview.getInt32(110),
      dataview.getInt32(114),
      dataview.getInt32(118),
    ],
    askQtys: [
      dataview.getInt32(122),
      dataview.getInt32(126),
      dataview.getInt32(130),
      dataview.getInt32(134),
      dataview.getInt32(138),
    ],
    volume: dataview.getInt32(142),
    totalTradeValue: dataview.getInt64(146),
    totalBuyQty: dataview.getInt64(154),
    totalSellQty: dataview.getInt64(162),
    open: dataview.getInt32(170),
    high: dataview.getInt32(174),
    low: dataview.getInt32(178),
    ltp: dataview.getInt32(182),
    lastTradedPrice: dataview.getInt32(182),
    ltt: dataview.getInt32(186),
    lowDpr: dataview.getInt32(190),
    highDpr: dataview.getInt32(194),
    closePrice: dataview.getInt32(198),
    close: dataview.getInt32(198),
    averageTradePrice: dataview.byteLength === 206 ? dataview.getInt32(202) : 0,
  };
}

export function snapquoteData(dataview) {
  return {
    exchange: dataview.getInt8(1),
    instrumentToken: dataview.getInt32(2),
    buyers: [
      dataview.getInt32(6),
      dataview.getInt32(10),
      dataview.getInt32(14),
      dataview.getInt32(18),
      dataview.getInt32(22),
    ],
    bidPrices: [
      dataview.getInt32(26),
      dataview.getInt32(30),
      dataview.getInt32(34),
      dataview.getInt32(38),
      dataview.getInt32(42),
    ],
    bidQtys: [
      dataview.getInt32(46),
      dataview.getInt32(50),
      dataview.getInt32(54),
      dataview.getInt32(58),
      dataview.getInt32(62),
    ],
    sellers: [
      dataview.getInt32(66),
      dataview.getInt32(70),
      dataview.getInt32(74),
      dataview.getInt32(78),
      dataview.getInt32(82),
    ],
    askPrices: [
      dataview.getInt32(86),
      dataview.getInt32(90),
      dataview.getInt32(94),
      dataview.getInt32(98),
      dataview.getInt32(102),
    ],
    askQtys: [
      dataview.getInt32(106),
      dataview.getInt32(110),
      dataview.getInt32(114),
      dataview.getInt32(118),
      dataview.getInt32(122),
    ],
    averageTradePrice: dataview.getInt32(126),
    open: dataview.getInt32(130),
    high: dataview.getInt32(134),
    low: dataview.getInt32(138),
    close: dataview.getInt32(142),
    totalBuyQty: dataview.getInt64(146),
    totalSellQty: dataview.getInt64(154),
    volume: dataview.getInt32(162),
  };
}

export function tbtSnapquoteData(dataview) {
  return {
    exchange: dataview.getInt8(1),
    instrumentToken: dataview.getInt32(2),
    // exchangeTimeInNano: dataview.getInt64(6),
    lastTradePrice: dataview.getInt32(14),
    lastTradeQuantity: dataview.getInt32(18),
    totalTradeQuantity: dataview.getInt64(22),
    buyers: [
      dataview.getInt32(30),
      dataview.getInt32(34),
      dataview.getInt32(38),
      dataview.getInt32(42),
      dataview.getInt32(46),
      dataview.getInt32(50),
      dataview.getInt32(54),
      dataview.getInt32(58),
      dataview.getInt32(62),
      dataview.getInt32(66),
      dataview.getInt32(70),
      dataview.getInt32(74),
      dataview.getInt32(78),
      dataview.getInt32(82),
      dataview.getInt32(86),
      dataview.getInt32(90),
      dataview.getInt32(94),
      dataview.getInt32(98),
      dataview.getInt32(102),
      dataview.getInt32(106),
    ],
    bidPrices: [
      dataview.getInt32(110),
      dataview.getInt32(114),
      dataview.getInt32(118),
      dataview.getInt32(122),
      dataview.getInt32(126),
      dataview.getInt32(130),
      dataview.getInt32(134),
      dataview.getInt32(138),
      dataview.getInt32(142),
      dataview.getInt32(146),
      dataview.getInt32(150),
      dataview.getInt32(154),
      dataview.getInt32(158),
      dataview.getInt32(162),
      dataview.getInt32(166),
      dataview.getInt32(170),
      dataview.getInt32(174),
      dataview.getInt32(178),
      dataview.getInt32(182),
      dataview.getInt32(186),
    ],
    bidQtys: [
      dataview.getInt32(190),
      dataview.getInt32(194),
      dataview.getInt32(198),
      dataview.getInt32(202),
      dataview.getInt32(206),
      dataview.getInt32(210),
      dataview.getInt32(214),
      dataview.getInt32(218),
      dataview.getInt32(222),
      dataview.getInt32(226),
      dataview.getInt32(230),
      dataview.getInt32(234),
      dataview.getInt32(238),
      dataview.getInt32(242),
      dataview.getInt32(246),
      dataview.getInt32(250),
      dataview.getInt32(254),
      dataview.getInt32(258),
      dataview.getInt32(262),
      dataview.getInt32(266),
    ],
    sellers: [
      dataview.getInt32(270),
      dataview.getInt32(274),
      dataview.getInt32(278),
      dataview.getInt32(282),
      dataview.getInt32(286),
      dataview.getInt32(290),
      dataview.getInt32(294),
      dataview.getInt32(298),
      dataview.getInt32(302),
      dataview.getInt32(306),
      dataview.getInt32(310),
      dataview.getInt32(314),
      dataview.getInt32(318),
      dataview.getInt32(322),
      dataview.getInt32(326),
      dataview.getInt32(330),
      dataview.getInt32(334),
      dataview.getInt32(338),
      dataview.getInt32(342),
      dataview.getInt32(346),
    ],
    askPrices: [
      dataview.getInt32(350),
      dataview.getInt32(354),
      dataview.getInt32(358),
      dataview.getInt32(362),
      dataview.getInt32(366),
      dataview.getInt32(370),
      dataview.getInt32(374),
      dataview.getInt32(378),
      dataview.getInt32(382),
      dataview.getInt32(386),
      dataview.getInt32(390),
      dataview.getInt32(394),
      dataview.getInt32(398),
      dataview.getInt32(402),
      dataview.getInt32(406),
      dataview.getInt32(410),
      dataview.getInt32(414),
      dataview.getInt32(418),
      dataview.getInt32(422),
      dataview.getInt32(426),
    ],
    askQtys: [
      dataview.getInt32(430),
      dataview.getInt32(434),
      dataview.getInt32(438),
      dataview.getInt32(442),
      dataview.getInt32(446),
      dataview.getInt32(450),
      dataview.getInt32(454),
      dataview.getInt32(458),
      dataview.getInt32(462),
      dataview.getInt32(466),
      dataview.getInt32(470),
      dataview.getInt32(474),
      dataview.getInt32(478),
      dataview.getInt32(482),
      dataview.getInt32(486),
      dataview.getInt32(490),
      dataview.getInt32(494),
      dataview.getInt32(498),
      dataview.getInt32(502),
      dataview.getInt32(506),
    ],
    averageTradePrice: dataview.getInt32(510),
    open: dataview.getInt32(514),
    high: dataview.getInt32(518),
    low: dataview.getInt32(522),
    close: dataview.getInt32(526),
    totalBuyQty: dataview.getInt64(530),
    totalSellQty: dataview.getInt64(538),
    volume: dataview.getInt32(546),
  };
}

export function marketStatus(dataview) {
  const exchange = dataview.getInt8(1);
  const marketTypeLength = dataview.getInt16(2);
  const marketType = dataview.getString(4, marketTypeLength);
  const marketTypeEnd = 4 + marketTypeLength;
  const messageLength = dataview.getInt16(marketTypeEnd);
  const messageStart = marketTypeEnd + 2;
  const message = dataview.getString(messageStart, messageLength);
  const messageEnd = messageStart + messageLength;
  const timestamp = dataview.getInt32(messageEnd);
  return {
    exchange,
    marketType,
    message,
    timestamp,
  };
}

export function exchangeMessage(dataview) {
  const exchange = dataview.getInt8(1);
  const messageLength = dataview.getInt16(2);
  const message = dataview.getString(4, messageLength);
  const messageEnd = 4 + messageLength;
  const timestamp = dataview.getInt32(messageEnd);
  return {
    exchange,
    message,
    timestamp,
  };
}

export function updates(dataview) {
  const stringifiedUpdate = dataview.getString(5) || "{}";
  return JSON.parse(stringifiedUpdate);
}

export function greekData(dataview) {


  return {
    exchange: dataview.getInt8(1),
    instrumentToken: dataview.getInt32(2),
    underlyingToken: dataview.getInt32(6),
    exchangeTimestamp: dataview.getInt32(10),
    delta: dataview.getBigInt64(14),
    gamma: dataview.getBigInt64(22),
    vega: dataview.getBigInt64(30),
    rho: dataview.getBigInt64(38),
    theta: dataview.getBigInt64(46),
    iv: dataview.getBigInt64(54),
    ltt: dataview.getInt32(62),
    ltq: dataview.getInt32(66),
    ltp: dataview.getInt32(70),
    currentOpenInterest: dataview.getInt32(74),
    initialOpenInterest: dataview.getInt32(78),
  };
}
